// extracted by mini-css-extract-plugin
module.exports = {"p-1":"Card_p-1__wRf4b","shootCard":"Card_shootCard__2y5PX","hidden":"Card_hidden__5tyLl","selected":"Card_selected__1Kpe0"};